import { getID } from "src/libs/utilities";
import { ALIGN, LANDING_TYPE_CONTENT } from "../interfaces";
import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated";

 

export default function features_cards():any[] {
    return [
        {
          "id": getID("features_cards"),
          "type": "features_cards",
          "vertical_align": "full",
          "border_radius": 5,
          "order": [
            "order",
            "icon",
            "title",
            "description",
            "links",
            "checkbox"
          ],
          "gap": 10,
          "animated": "fadeInUp",
          "animated_delay": "waterfall",
          "columns": 4,
          "card_fields": {
            "order": {
                "id": getID("order"),
                "significant_zero": false,
                "is_show_full": true,
                "card_fields_style": {
                    "position": "absolute",
                    "top": 10,
                    "right": 10
                },
                "style": {
                    "fontFamily": "Yanone Kaffeesatz, sans-serif",
                    "fontSize": "1.1em",
                    "opacity": 0.75
                }
            },
            "icon": {
              "id": getID("icon"),
              "hover_size": 4, 
              "style": { "height": 120, "width": "100%", "backgroundSize": 70, "backgroundRepeat": "no-repeat", "backgroundPosition": "center", "display": "flex", "justifyContent": "center" }
            },
            "iconMedallion": { "id": getID("icon-m"),"radius": 100, "margin": 25 },
            "title": {
                "id": getID("title"),
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "textTransform": "uppercase"
              }
            },
            "checkbox": { "id": getID("check"),"style": { "padding": "10px 30px" } }
          },
          "cards": [
            {
              "id": getID("card"),
              "order": {},
              "icon": {  "id": getID(""), "data": "/assets/img/friends-icon.png" },
              "iconMedallion": { "id": getID(""), "data": "/assets/img/friends-icon.png" },
              "title": { "id": getID(""), "data": "Втираемся в доверие" },
              "description": {
                "id": getID(""), "data": "<p>Это всё конечно хорошо. Это просто радувает нас, как ёлочка"
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 0 }
                ]
              }
            },
            {
              "id": getID("card"),
              "order": {},
              "icon": { "id": getID(""), "data": "/assets/img/the-under-starts-city-2.png" },
              "iconMedallion": {
                "id": getID(""), "data": "/assets/img/the-under-starts-city-2.png"
              },
              "title": { "id": getID(""), "data": "Комические куплеты" },
              "description": { "id": getID(""), "data": "<p>Реальность — это суровое место..." },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 0 },
                  { "title": "Входим в двери", "checked": 0 },
                  { "title": "Шаманим", "checked": 1 }
                ]
              }
            },
            {
              "id": getID("card"),
              "order": {},
              "icon": { "id": getID(""), "data": "/assets/img/administrators-icon.png" },
              "iconMedallion": {
                "id": getID(""), "data": "/assets/img/administrators-icon.png"
              },
              "title": { "id": getID(""), "data": "Сбыча" },
              "description": {
                "id": getID(""), "data": "<p>На Урале какие-то люди может быть есть. Тогда за три дня не удалось..."
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 0 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 1 }
                ]
              }
            }
          ],
          "style": {
            "backgroundColor": "var(--force-plain-secondary-opacity-color)",
            "border": "1px solid var(--force-mini-contast-color)"
          },
          defaultTitle: "Минималистические карточки",
        },
        {
          "id": getID("features_cards"),
          "type": "features_cards",
          "vertical_align": "full",
          "border_radius": 30,
          "order": [
            "iconMedallion",
            "title",
            "links",
            "checkbox",
            "divider",
            "button"
          ],
          "gap": 20,
          "animated": "fadeInRight",
          "animated_delay": "waterfall",
          "border": {
            "stroke": "var(--force-contast-color)",
            "strokeWidth": 1,
            "borderType": "curve",
            "isClosed": true,
            "path": [
              { "x": 40, "y": 0, "left": 1, "top": 1 },
              { "x": 40, "y": 40, "right": 1, "top": 1 },
              { "x": -30, "y": 10, "bottom": 1, "right": 1 },
              { "x": -40, "y": 10, "bottom": 1, "left": 1 }
            ]
          },
          "columns": 4,
          "card_fields": {
            "icon": {
              "id": getID(""), 
              "hover_size": 2,
              "style": { "backgroundSize": 70, "backgroundRepeat": "no-repeat" }
            },
            "iconMedallion": {
                "id": getID("icon-medallion"), 
              "radius": 100,
              "margin": 25,
              "style": {
                "backgroundColor": "var(--force-plain-color)",
                 // "border": "1px solid var(--force-mini-contast-color)",
                "boxShadow": "0 7px 5px 0px #00000012"
              }
            },
            "title": {
                "id": getID(""), 
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "textTransform": "uppercase"
              }
            },
            "divider": { "id": getID(""), "divider_height": "1px" },
            "speech_bubble": {
                "id": getID(""),  
              "strokeWidth": 2,
              "tailPositionX": 85,
              "style": {
                "boxShadow": "0 7px 5px 0px #00000012",
                "marginButtom": -10
              },
              "data": { "type": "html", "className": "py-2 px-3" }
            },
            "person": { "id": getID(""), "data": { "avatarWidth": 75, "avatarHeight": 75 } },
            "checkbox": { "id": getID(""), "style": { "padding": "10px 30px" } },
            "button": {
                "id": getID(""), 
              "style": {
                "height": "auto",
                "padding": "20px",
                "paddingBottom": "auto"
              }
            },
            "divider-1": { "id": getID(""), "divider_height": "0px" }
          },
          "cards": [
            {
              "id": getID("card"),
              "icon": { "id": getID(""), "data": "/assets/img/friends-icon.png" },
              "iconMedallion": { "id": getID(""), "data": "/assets/img/friends-icon.png" },
              "title": { "id": getID(""), "data": "Втираемся в доверие" },
              "divider": {},
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Это всё конечно хорошо. Это просто радувает нас, как ёлочка"
                }
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("User"), 
                    "display_name": "Кукушечкова Алевтина Исаевна",
                    "first_name": "Кукушечкова",
                    "second_name": "Алевтина Исаевна",
                    "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg"
                  }
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 0 }
                ]
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": { "id": getID(""), "data": "/assets/img/the-under-starts-city-2.png" },
              "iconMedallion": {
                "id": getID(""), 
                "data": "/assets/img/the-under-starts-city-2.png"
              },
              "title": { "id": getID(""), "data": "Комические куплеты" },
              "divider": {},
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Реальность — это суровое место..."
                }
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("user"), 
                    "display_name": "Кукушечкова Алевтина Исаевна",
                    "first_name": "Кукушечкова",
                    "second_name": "Алевтина Исаевна",
                    "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg"
                  }
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 0 },
                  { "title": "Входим в двери", "checked": 0 },
                  { "title": "Шаманим", "checked": 1 }
                ]
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": { "data": "/assets/img/administrators-icon.png" },
              "iconMedallion": {
                "data": "/assets/img/administrators-icon.png"
              },
              "title": { "data": "Сбыча" },
              "divider": {},
              "speech_bubble": {
                "data": {
                  "id": "103-card-1-bubble",
                  "data": "<p>На Урале какие-то люди может быть есть. Тогда за три дня не удалось..."
                }
              },
              "checkbox": {
                "data": [
                  { "title": "Поём песни", "checked": 0 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 1 }
                ]
              },
              "person": {
                "data": {
                  "user": {
                    "id": "11",
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            }
          ],
          "style": { "border": "1px solid var(--force-mini-contast-color)" },
          defaultTitle: "Пизанские мегалиты",
        },
        {
          "id": getID("features_cards"),
          "type": "features_cards",
          "feedType": "vertical_timeline",
          "vertival_align": "full",
          "border_radius": 12,
          "order": ["title", "time"],
          "gap": 25,
          "is_two_side": 1,
          "animated": "fadeInLeft",
          "animated_delay": "waterfall",
          "border": {
            "stroke": "var(--force-contrast-opacity-color)",
            "strokeWidth": 1,
            "borderType": ""
          },
          "dots": {
            "type": "sinusoid",
            "perimeter": 36,
            "color": "var(--force-plain-color)",
            "fontColor": "var(--force-contast-color)",
            "fontSize": 13,
            "weight": 1,
            "round": 22,
            "significant_zero": true,
            "amplitude": 0,
            "image": "https://i.pinimg.com/736x/9d/1d/10/9d1d108b34722181206e31ef94b61e1f.jpg",
            "length": 0.6,
            "phase": 0,
            "stroke_width": 2,
            "svg_style--": { "strokeDasharray": "4 2" },
            "dot_style": { "border": "2px solid var(--force-contast-color)" }
          },
          "card_fields": {
            "icon": {
              "id": getID(""), 
              "hover_size": 2,
              "style": { "backgroundSize": 70, "backgroundRepeat": "no-repeat" }
            },
            "time": {
              "id": getID(""), 
              "style": { "display": "flex", "justifyContent": "center" },
              "format": "D MMM YY года",
              "className": "p-2 my-3 bg-transparent lead",
              "labelClassName": "",
              "minimal": true
            },
            "iconMedallion": {
              "id": getID(""), 
              "radius": 100,
              "margin": 25,
              "hover_size": 2,
              "style": {
                "backgroundColor": "var(--force-plain-color)",
                "border": "1px solid var(--force-mini-contast-color)",
                "boxShadow": "0 7px 5px 0px #00000012"
              }
            },
            "title": {
              "id": getID(""), 
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "borderBottom": "1px solid var(--force-mini-contast-color)",
                "textTransform": "uppercase"
              }
            },
            "speech_bubble": {
              "id": getID(""), 
              "strokeWidth": 2,
              "tailPositionX": 85,
              "style": {
                "boxShadow": "0 7px 5px 0px #00000012",
                "marginButtom": -10
              },
              "data": { "id": getID(""), "type": "html", "className": "py-2 px-3" }
            },
            "person": { "id": getID(""),  "data": { "avatarWidth": 75, "avatarHeight": 75 } },
            "checkbox": { "id": getID(""), "style": { "padding": "10px 30px" } },
            "button": {
              "id": getID(""), 
              "style": {
                "height": "auto",
                "padding": "20px",
                "paddingBottom": "auto"
              }
            },
            "divider": { "id": getID(""), "divider_height": "0px" }
          },
          "cards": [
            {
              "id": getID("card"),
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10751/10751110.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10751/10751110.png"
              },
              "title": { "id": getID(""), "data": "Защиты жизненных проектов 11-классниками" },
              "time": { "id": getID(""), "start_time": 1757997073, "finish_time": 1757997105 },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": "101-card-12-bubble-1",
                  "data": "<p>Это всё конечно хорошо. Это просто радувает нас, как ёлочка"
                }
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("user"), 
                    "display_name": "Кукушечкова Алевтина Исаевна",
                    "first_name": "Кукушечкова",
                    "second_name": "Алевтина Исаевна",
                    "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg"
                  }
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 0 }
                ]
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "dots": { "id": getID(""), "color": "var(--danger)", "fontColor": "#FFFFFF" },
              "icon": { 
                "id": getID(""), 
                "data":"https://cdn-icons-png.flaticon.com/128/10751/10751146.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10751/10751146.png"
              },
              "title": {
                "id": getID(""), 
                "data": "Такт 1. Рефлексия интересов, опыта и возможностей",
                "style": { "color": "var(--actual-success-color)" }
              },
              "time": { "id": getID(""), "start_time": 175799707, "finish_time": 1757997105 },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Реальность — это суровое место..."
                }
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID(""), 
                    "display_name": "Кукушечкова Алевтина Исаевна",
                    "first_name": "Кукушечкова",
                    "second_name": "Алевтина Исаевна",
                    "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg"
                  }
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 0 },
                  { "title": "Входим в двери", "checked": 0 },
                  { "title": "Шаманим", "checked": 1 }
                ]
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "title": {
                "id": getID(""), 
                "data": "Игра «Территория» - решение правовых и финансовых ситуаций"
              },
              "time": { "id": getID(""), "start_time": 175799707, "finish_time": 1757997105 },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>На Урале какие-то люди может быть есть. Тогда за три дня не удалось..."
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 0 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 1 }
                ]
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("user"), 
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7505/7505823.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7505/7505823.png"
              },
              "title": {
                "id": getID(""), 
                "data": "Такт 2. Анализ профессий и вариантов образования"
              },
              "time": { "id": getID(""), "start_time": 175799707, "finish_time": 1757997105 },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Нам нужен мощный телепат"
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 0 }
                ]
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("user"), 
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7506/7506193.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7506/7506193.png"
              },
              "title": {
                "id": getID(""), 
                "data": "Такт 3. Выбор профессии, проектирование траектории"
              },
              "time": { "id": getID(""), "start_time": 175799707, "finish_time": 1757997105 },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Она хотела, чтобы ее выслушали..."
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 0 }
                ]
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": "155",
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7506/7506086.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7506/7506086.png"
              },
              "title": { "id": getID(""), "data": "Итоговое представление жизненного проекта" },
              "time": { "id": getID(""), "start_time": 175799707, "finish_time": 1757997105 },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Будто ловит мысли из чужого мира."
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 0 }
                ]
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("user"), 
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            }
          ],
          "style": { "border": "1px solid var(--force-contast-color)" },
            defaultTitle: "Вертикальный таймлайн",
        },
        {
          "id": getID("features_cards"),
          "type": "features_cards",
          "feedType": "vertical_timeline",
          "vertival_align": "full",
          "border_radius": 3,
          "order": ["title", "links", "checkbox"],
          "gap": 25,
          "is_two_side": 1,
          "animated": "fadeInLeft",
          "animated_delay": "waterfall",
          "border": {
            "stroke": "var(--force-contrast-opacity-color)",
            "strokeWidth": 1,
            "borderType": "nose"
          },
          "dots": {
            "type": "gallery",
            "perimeter": 36,
            "color": "var(--force-plain-color)",
            "fontColor": "var(--force-contast-color)",
            "fontSize": 13,
            "weight": 1,
            "round": 22,
            "significant_zero": true,
            "amplitude": 20,
            "image": "https://i.pinimg.com/736x/9d/1d/10/9d1d108b34722181206e31ef94b61e1f.jpg",
            "length": 0.45,
            "phase": 3.141,
            "stroke_width": 240,
            "svg_style--": { "strokeDasharray": "4 2" },
            "dot_style": { "border": "2px solid var(--force-contast-color)" }
          },
          "card_fields": {
            "icon": {
              "id": getID(""), 
              "style": { "backgroundSize": 70, "backgroundRepeat": "no-repeat" }
            },
            "iconMedallion": {
              "id": getID(""), 
              "radius": 100,
              "margin": 25,
              "style": {
                "backgroundColor": "var(--force-plain-color)",
                "border": "1px solid var(--force-mini-contast-color)",
                "boxShadow": "0 7px 5px 0px #00000012"
              }
            },
            "title": {
              "id": getID(""), 
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "borderBottom": "1px solid var(--force-mini-contast-color)",
                "textTransform": "uppercase"
              }
            },
            "speech_bubble": {
              "id": getID(""), 
              "strokeWidth": 2,
              "tailPositionX": 85,
              "style": {
                "boxShadow": "0 7px 5px 0px #00000012",
                "marginButtom": -10
              },
              "data": { "id": getID(""), "type": "html", "className": "py-2 px-3" }
            },
            "person": { "id": getID(""), "data": { "avatarWidth": 75, "avatarHeight": 75 } },
            "checkbox": { "id": getID(""), "style": { "padding": "10px 30px" } },
            "button": {
              "id": getID(""), 
              "style": {
                "height": "auto",
                "padding": "20px",
                "paddingBottom": "auto"
              }
            },
            "divider": { "divider_height": "0px" }
          },
          "cards": [
            {
              "id": getID("card"),
              "icon": {
                "id": getID(""), 
                "hover_size": 2,
                "data": "https://cdn-icons-png.flaticon.com/128/10751/10751110.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "hover_size": 2,
                "data": "https://cdn-icons-png.flaticon.com/128/10751/10751110.png"
              },
              "title": { "id": getID(""), "data": "Втираемся в доверие" },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Это всё конечно хорошо. Это просто радувает нас, как ёлочка"
                }
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": "11",
                    "display_name": "Кукушечкова Алевтина Исаевна",
                    "first_name": "Кукушечкова",
                    "second_name": "Алевтина Исаевна",
                    "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg"
                  }
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 0 }
                ]
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "dots": {
                "id": getID(""), 
                "color--": "var(--actual-success-color)",
                "fontColor": "var(--actual-success-color)",
                "perimeter": 60,
                "round": 60
              },
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10751/10751146.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10751/10751146.png"
              },
              "title": {
                "id": getID(""), 
                "data": "Комические куплеты",
                "style": { "color": "var(--actual-success-color)" }
              },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Реальность — это суровое место..."
                }
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("user"), 
                    "display_name": "Кукушечкова Алевтина Исаевна",
                    "first_name": "Кукушечкова",
                    "second_name": "Алевтина Исаевна",
                    "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg"
                  }
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 0 },
                  { "title": "Входим в двери", "checked": 0 },
                  { "title": "Шаманим", "checked": 1 }
                ]
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id":  getID("card"),
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "title": { "id": getID(""), "data": "Сбыча" },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>На Урале какие-то люди может быть есть. Тогда за три дня не удалось..."
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 0 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 1 }
                ]
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID(""), 
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "data": "https://cdn-icons-png.flaticon.com/128/7505/7505823.png"
              },
              "iconMedallion": {
                "data": "https://cdn-icons-png.flaticon.com/128/7505/7505823.png"
              },
              "title": { "data": "Поначалу" },
              "speech_bubble": {
                "data": {
                  "id": "104-card-1-bubble",
                  "data": "<p>Нам нужен мощный телепат"
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 0 }
                ]
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID(""), 
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7506/7506193.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7506/7506193.png"
              },
              "title": { "id": getID(""), "data": "Красные ступени" },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Она хотела, чтобы ее выслушали..."
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 0 }
                ]
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("user"), 
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7506/7506086.png"
              },
              "iconMedallion": {
                "id": getID(""), 
                "data": "https://cdn-icons-png.flaticon.com/128/7506/7506086.png"
              },
              "title": { "id": getID(""), "data": "Хорошие дни" },
              "speech_bubble": {
                "id": getID(""), 
                "data": {
                  "id": getID(""), 
                  "data": "<p>Будто ловит мысли из чужого мира."
                }
              },
              "checkbox": {
                "id": getID(""), 
                "data": [
                  { "title": "Поём песни", "checked": 1 },
                  { "title": "Входим в двери", "checked": 1 },
                  { "title": "Шаманим", "checked": 1 },
                  { "title": "Обгоняем по всем параметрам", "checked": 0 }
                ]
              },
              "person": {
                "id": getID(""), 
                "data": {
                  "user": {
                    "id": getID("user"), 
                    "display_name--": "Сигизмундов Савва Шехерезадович",
                    "first_name": "Сигизмундов",
                    "second_name": "Савва Шехерезадович",
                    "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                  }
                }
              },
              "button": {
                "id": getID(""), 
                "data": {
                  "type": "inner_link",
                  "label": "Подробнее",
                  "url": "/"
                }
              }
            }
          ],
          "style": { "border": "1px solid var(--force-contast-color)" },
            defaultTitle: "Вертикальный таймлайн с иллюстрацией",
        },
        {
          "id": getID("features_cards"),
          "type": LANDING_TYPE_CONTENT.FEATURES_CARDS,
          "vertical_align": ALIGN.FULL,
          "border_radius": 5,
          "order": ["iconMedallion", "title", "description"],
          "gap": 10,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "columns": 3,
          "card_fields": {
            "icon": {
              "id": getID("icon"),
              "hover_size": 2,
              "style": { "backgroundSize": 70, "backgroundRepeat": "no-repeat" }
            },
            "iconMedallion": {
              "id": getID("medallion"),
              "radius": 75,
              "margin": 20,
              "isSquare": true,
              "style": { "backgroundColor": "var(--force-plain-color)" },
              "hover_size": 2
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "textTransform": "uppercase"
              }
            },
            "checkbox": {
              "id": getID("checkbox"),
              "style": { "padding": "10px 30px" }
            }
          },
          "cards": [
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "iconMedallion": {
                "id": getID("medallion"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "title": {
                "id": getID("title"),
                "data": "Коммуникации"
              },
              "description": {
                "id": getID("description"),
                "data": "<p>Самые лучшие коммуникационные технологии России. Вы можете заказать у нас учебный курс или полноценное развертывание в любой точке страны."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "iconMedallion": {
                "id": getID("medallion"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "title": {
                "id": getID("title"),
                "data": "Экологичность"
              },
              "description": {
                "id": getID("description"),
                "data": "<p>Только нам под силу организовать в Вашей команде или корпорации общение без абьюза и доминирования...."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "iconMedallion": {
                "id": getID("medallion"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "title": {
                "id": getID("title"),
                "data": "Масштабирование"
              },
              "description": {
                "id": getID("description"),
                "data": "<p>Распространим Ваши каналы общения куда только захотите."
              }
            }
          ],
          "style": {},
          "defaultTitle": "Прозрачные карточки с квадратными иконками"
        }, 
        {
          "id": getID("features_cards"),
          "type": LANDING_TYPE_CONTENT.FEATURES_CARDS,
          "vertical_align": ALIGN.START,
          "border_radius": 5,
          "order": ["icon", "title", "description"],
          "gap": 10,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "columns": 1,
          "grid": "'AABB BBBC CCCC' 'AADD DDDD DDDD'  'AAEE EEEE EEEE' 'AAFF FFFF FFFF' 'AAGG GGGG GGGG'",
          "gridColumns": "auto 40px",
          "card_fields": {
            "icon": {
              "id": getID("icon"),
              hover_size: 2, 
              "style": {
                "backgroundSize": 40,
                "backgroundRepeat": "no-repeat",
                "backgroundColor": "transparent",
                "width": 40,
                "height": 40,
                "opacity": 0.75
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 1,
                "gridRowEnd": 3,
                "width": "100%",
                "height": "100%",
                "justifyContent": "center",
                "alignItems": "center"
              }
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 700,
                "fontSize": 20,
                "textTransform": "none",
                "textAlign": "left",
                "justifyContent": "flex-start",
                "padding": "12px 12px 0 12px"
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 1,
                "gridColumnEnd": 2,
                "gridRowStart": 1,
                "gridRowEnd": 1
              }
            },
            "description": {
              "id": getID("description"),
              "style": { 
                "textAlign": "left",
                "justifyContent": "flex-start"
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 1,
                "gridColumnEnd": 2,
                "gridRowStart": 2,
                "gridRowEnd": 2
              }
            },
            "checkbox": {
              "id": getID("checkbox"),
              "style": { "padding": "10px 30px" },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 1,
                "gridColumnEnd": 2,
                "gridRowStart": 3,
                "gridRowEnd": 3
              }
            }
          },
          "cards": [
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "title": { "id":  getID("title"), "data": "Коммуникации" },
              "description": {
                "id": getID("description"),
                "data": "<p>Самые лучшие коммуникационные технологии России. Вы можете заказать у нас учебный курс или полноценное развертывание в любой точке страны."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "title": { "id": getID("title"), "data": "Экологичность" },
              "description": {
                "id": getID("description"),
                "data": "<p>Только нам под силу организовать в Вашей команде или корпорации общение без абьюза и доминирования...."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "title": { "id": getID("title"), "data": "Масштабирование" },
              "description": {
                "id": getID("description"),
                "data": "<p>Распространим Ваши каналы общения куда только захотите."
              }
            }
          ],
          "style": {},
          "defaultTitle": "Горизонтальные карточки с иконками справа"
        },
        {
          "id": getID("features_cards"),
          "type": LANDING_TYPE_CONTENT.FEATURES_CARDS,
          "vertical_align": ALIGN.START,
          "border_radius": 5,
          "order": ["icon", "title", "description"],
          "gap": 10,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "columns": 1,
          "grid": "'AABB BBBC CCCC' 'AADD DDDD DDDD'  'AAEE EEEE EEEE' 'AAFF FFFF FFFF' 'AAGG GGGG GGGG'",
          "gridColumns": "80px auto ",
          "card_fields": {
            "icon": {
              "id": getID("icon"),
              "className": "svg-force-contrast",
              "hover_size": 2,
              "style": {
                "backgroundSize": 30,
                "backgroundRepeat": "no-repeat",
                "backgroundColor": "transparent",
                "width": 30,
                "height": 30,
                "opacity": 0.75
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 1,
                "gridColumnEnd": 1,
                "gridRowStart": 1,
                "gridRowEnd": 3,
                "width": 70,
                "height": 70,
                "justifyContent": "center",
                "alignItems": "center",
                "marginTop": "auto",
                "marginBottom": "auto",
                "backgroundColor": "var(--force-plain-color)",
                "borderRadius": 35
              }
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 700,
                "fontSize": 20,
                "textTransform": "none",
                "textAlign": "left",
                "justifyContent": "flex-start",
                "padding": "12px 12px 0 12px"
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 1,
                "gridRowEnd": 1
              }
            },
            "description": {
              "id": getID("description"),
              "style": { "textAlign": "left", "justifyContent": "flex-start" },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 2,
                "gridRowEnd": 2
              }
            },
            "checkbox": {
              "id": getID("checkbox"),
              "style": { "padding": "10px 30px" },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 3,
                "gridRowEnd": 3
              }
            }
          },
          "cards": [
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "title": { "id": getID("title"), "data": "Коммуникации" },
              "description": {
                "id": getID("description"),
                "data": "<p>Самые лучшие коммуникационные технологии России. Вы можете заказать у нас учебный курс или полноценное развертывание в любой точке страны."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id":  getID("icon"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "title": { "id": getID("title"), "data": "Экологичность" },
              "description": {
                "id": getID("description"),
                "data": "<p>Только нам под силу организовать в Вашей команде или корпорации общение без абьюза и доминирования...."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id":  getID("icon"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "title": { "id": getID("title"), "data": "Масштабирование" },
              "description": {
                "id": getID("description"),
                "data": "<p>Распространим Ваши каналы общения куда только захотите."
              }
            }
          ],
          "style": {},
          "defaultTitle": "Горизонтальные карточки с иконками слева"
        },
        {
          "id": getID("features_cards"),
          "type": LANDING_TYPE_CONTENT.FEATURES_CARDS,
          "vertical_align": ALIGN.START,
          "border_radius": 5,
          "order": ["icon", "title", "description"],
          "gap": 10,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "columns": 1,
          "thumbnail": {
            data: {
              src: "https://i.pinimg.com/736x/fc/5d/a4/fc5da4d9a389a90f75ddd5a220a45d42.jpg"
            },
            hover_size: 2,
          },
          "proportia": 0.33,
          "isRightThumbnail": true,
          "grid": "'AABB BBBC CCCC' 'AADD DDDD DDDD'  'AAEE EEEE EEEE' 'AAFF FFFF FFFF' 'AAGG GGGG GGGG'",
          "gridColumns": "40px auto ",
          "card_fields": {
            "icon": {
              "id": getID("icon"),
              "hover_size": 2,
              "className": "svg-force-contrast",
              "style": {
                "backgroundSize": 30,
                "backgroundRepeat": "no-repeat",
                "backgroundColor": "transparent",
                "width": 30,
                "height": 30,
                "opacity": 0.75
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 1,
                "gridColumnEnd": 1,
                "gridRowStart": 1,
                "gridRowEnd": 3,
                "width": 40,
                "height": 40,
                "justifyContent": "center",
                "alignItems": "center",
                "marginTop": "auto",
                "marginBottom": "auto"
              }
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 100,
                "fontSize": 16,
                "textTransform": "uppercase",
                "textAlign": "left",
                letterSpacing: 2,
                "justifyContent": "flex-start",
                "padding": "12px 12px 0 12px"
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 1,
                "gridRowEnd": 1
              }
            },
            "description": {
              "id": getID("description"),
              "style": { "textAlign": "left", "justifyContent": "flex-start" },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 2,
                "gridRowEnd": 2
              }
            },
            "checkbox": {
              "id": getID("checkbox"),
              "style": { "padding": "10px 30px" },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 3,
                "gridRowEnd": 3
              }
            }
          },
          "cards": [
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "title": { "id": getID("title"), "data": "Коммуникации" },
              "description": {
                "id": getID("description"),
                "data": "<p>Самые лучшие коммуникационные технологии России. Вы можете заказать у нас учебный курс или полноценное развертывание в любой точке страны."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "title": { "id":  getID("title"), "data": "Экологичность" },
              "description": {
                "id": getID("description"),
                "data": "<p>Только нам под силу организовать в Вашей команде или корпорации общение без абьюза и доминирования...."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "title": { "id": getID("title"), "data": "Масштабирование" },
              "description": {
                "id": getID("description"),
                "data": "<p>Распространим Ваши каналы общения куда только захотите."
              }
            }
          ],
          "style": {},
          "defaultTitle": "Строки с иллюстрацией"
        },
        {
          "id": getID("features_cards"),
          "type": LANDING_TYPE_CONTENT.FEATURES_CARDS,
          "vertical_align": ALIGN.START,
          "border_radius": 5,
          "order": ["icon", "title", "description"],
          "gap": 10,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "columns": 2, 
          "thumbnail": {
            data: {
              src: "https://i.pinimg.com/736x/43/61/aa/4361aadaf548b956c8b68652ff7180f6.jpg"
            },
            hover_size: 2,
          },
          "proportia": 0.33,
          "card_fields": {
            "icon": {
              "id": getID("icon"),
              "hover_size": -2,
              className: "svg-force-contrast",
              "style": {
                "backgroundSize": 40,
                "marginLeft": 10,
                "backgroundRepeat": "no-repeat",
                "backgroundColor": "transparent",
                "width": 50,
                "height": 40,
                "opacity": 0.75
              } 
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 700,
                "fontSize": 20,
                "textTransform": "none",
                "textAlign": "left",
                "justifyContent": "flex-start",
                "padding": "12px 12px 0 12px"
              } 
            },
            "description": {
              "id": getID("description"),
              "style": { "textAlign": "left", "justifyContent": "flex-start" } 
            },
            "checkbox": {
              "id": getID("checkbox"),
              "style": { "padding": "10px 30px" } 
            }
          },
          "cards": [
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "title": { "id": getID("title"), "data": "Коммуникации" },
              "description": {
                "id": getID("description"),
                "data": "<p>Самые лучшие коммуникационные технологии России. Вы можете заказать у нас учебный курс или полноценное развертывание в любой точке страны."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "title": { "id": getID("title"), "data": "Экологичность" },
              "description": {
                "id": getID("description"),
                "data": "<p>Только нам под силу организовать в Вашей команде или корпорации общение без абьюза и доминирования...."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion") ,
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "title": { "id": getID("title"), "data": "Масштабирование" },
              "description": {
                "id": getID("description"),
                "data": "<p>Распространим Ваши каналы общения куда только захотите."
              }
            },
            {
              "id": getID("card"),
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/HeadsetOutline.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/HeadsetOutline.svg"
              },
              "title": { "id": getID("title"), "data": "Сопровождение" },
              "description": {
                "id": getID("description"),
                "data": "<p>Поддержим Вас на всех этапах жизненного цикла. Закачаетесь!"
              }
            }
          ],
          "style": {},
          "defaultTitle": "Карточки в 2 колонки и иллюстрация"
        },
        {
          "id": getID("features_cards"),
          "type": LANDING_TYPE_CONTENT.FEATURES_CARDS,
          "vertical_align": ALIGN.START,
          "border_radius": 5, 
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "order": ["order", "title", "description"],
          "gap": 10, 
          "columns": 1,
          "thumbnail": {
            data: {
              "src" : "https://i.pinimg.com/1200x/fb/11/0c/fb110c6ba9f16901157bc5fdcfd13d68.jpg"
            },
            hover_size: 2
          },
          "proportia": 0.33,
          "isRightThumbnail": true,
          "grid": "'AABB BBBC CCCC' 'AADD DDDD DDDD'  'AAEE EEEE EEEE' 'AAFF FFFF FFFF' 'AAGG GGGG GGGG'",
          "gridColumns": "50px auto ",
          "card_fields": {
            "order": {
              "id": getID("order"),
              "hover_size": 2, 
              "style": { 
                "backgroundColor": "var(--force-contast-color)",
                "color": "var(--force-plain-color)",
                "width": 33,
                "height": 33,
                "fontSize": 20,
                "textAlign": "center",
                "fontWeight": 800
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 1,
                "gridColumnEnd": 1,
                "gridRowStart": 1,
                "gridRowEnd": 3,
                "width": 50,
                "height": 50,
                "justifyContent": "center",
                "alignItems": "center",
                "marginTop": "auto",
                "marginBottom": "auto",
                "borderRadius": 3
              }
            },
            "icon": {
              "id": getID("icon"),
              "hover_size": 2,
              "className": "svg-force-contrast",
              "style": {
                "backgroundSize": 30,
                "backgroundRepeat": "no-repeat",
                "backgroundColor": "transparent",
                "width": 30,
                "height": 30,
                "opacity": 0.75
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 1,
                "gridColumnEnd": 1,
                "gridRowStart": 1,
                "gridRowEnd": 3,
                "width": 40,
                "height": 40,
                "justifyContent": "center",
                "alignItems": "center",
                "marginTop": "auto",
                "marginBottom": "auto"
              }
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 100,
                "fontSize": 16,
                "textTransform": "uppercase",
                "textAlign": "left",
                "letterSpacing": 2,
                "justifyContent": "flex-start",
                "padding": "12px 12px 0 12px"
              },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 1,
                "gridRowEnd": 1
              }
            },
            "description": {
              "id": getID("description"),
              "style": { "textAlign": "left", "justifyContent": "flex-start" },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 2,
                "gridRowEnd": 2
              }
            },
            "checkbox": {
              "id": getID("checkbox") ,
              "style": { "padding": "10px 30px" },
              "card_fields_style": {
                "display": "grid",
                "gridColumnStart": 2,
                "gridColumnEnd": 2,
                "gridRowStart": 3,
                "gridRowEnd": 3
              }
            }
          },
          "cards": [
            {
              "id": getID("card"),
              "order": {
                "id": getID("order")  
              },
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/UserVoice.svg"
              },
              "title": { "id": getID("title"), "data": "Коммуникации" },
              "description": {
                "id": getID("description"),
                "data": "<p>Самые лучшие коммуникационные технологии России. Вы можете заказать у нас учебный курс или полноценное развертывание в любой точке страны."
              }
            },
            {
              "id": getID("card"),
              "order": {
                "id":  getID("order") 
              },
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/BxsLeaf.svg"
              },
              "title": { "id": getID("title"), "data": "Экологичность" },
              "description": {
                "id": getID("description"),
                "data": "<p>Только нам под силу организовать в Вашей команде или корпорации общение без абьюза и доминирования...."
              }
            },
            {
              "id": getID("card"),
              "order": {
                "id":  getID("order")
              },
              "icon": {
                "id": getID("icon"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "iconMedallion": {
                "id": getID("icon-medallion"),
                "data": "/assets/img/landing/examples/MessageRoundedAdd.svg"
              },
              "title": { "id": getID("title"), "data": "Масштабирование" },
              "description": {
                "id": getID("description"),
                "data": "<p>Распространим Ваши каналы общения куда только захотите."
              }
            }
          ],
          "style": {},
          "defaultTitle": "Нумерованные строки с иллюстрацией"
        }
    ]
}